import React from 'react'
import { Row } from 'react-bootstrap'

const IconRow = ({ children }) => (
    <Row>
        {children}
    </Row>
)

export default IconRow